const url = "https://client.quantbridge.co";

export { url }